import React, { useEffect } from "react";

import { titlePrefix } from "@assets/constants";
import { Page } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import UserTable from "./userTable";

const UserProfile: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = titlePrefix + t("MENU_USER_PROFILE");
  }, [t]);

  return (
    <Page className="md:m-6 md:mx-auto md:max-w-[1204px] md:p-2" title={t("MENU_USER_PROFILE")}>
      <UserTable />
    </Page>
  );
};

export default UserProfile;
